class ReasonCodeService extends BaseService
	@register()
	@inject 'BACKEND_REASON_CODE_ENTITY_TYPE'

	getGroupedTypes: ->
		types = @BACKEND_REASON_CODE_ENTITY_TYPE

		return {
			negative: [
				types.NEGATIVE
				types.SALE
				types.RESERVED
				types.TRANSFER_OUT
			]
			neutral: [
				types.NEUTRAL
				types.COUNT
			]
			positive: [
				types.POSITIVE
				types.RETURN
				types.GOODS_RECEIVED
				types.RESERVATION_CANCELLED
				types.TRANSFER_IN
			]
		}

	getGroupedReasonCodes: (reasonCodes) ->
		types = @getGroupedTypes()

		return {
			negative: _.filter reasonCodes, (code) => types.negative.includes code.entity_type
			neutral: _.filter reasonCodes, (code) => types.neutral.includes code.entity_type
			positive: _.filter reasonCodes, (code) => types.positive.includes code.entity_type
		}
